import { createTypes, createAsyncAction } from '@flux';


type ActionTypes = {
	'FETCH_SESSION_CONTEXT': string;
	'LOGOUT': string;
}

const types = createTypes<ActionTypes>([
	'FETCH_SESSION_CONTEXT',
	'LOGOUT'
], 'SHARED');

const actions = {
	fetchSessionContext: createAsyncAction(types.FETCH_SESSION_CONTEXT)(
		(box, ticketuid: string) => box.api.auth.security.rest.fetchSessionContext(ticketuid)
	),
	logoutAction: createAsyncAction(types.LOGOUT)(
		(box) => box.api.auth.security.rest.logout()
	)
};

export const contextActionsPack = {
	types,
	actions
}
